import { combineReducers } from 'redux';
import updateCustomer from './UpdateCustomerInfo/reducer';

export default combineReducers({ updateCustomer });



// WEBPACK FOOTER //
// ./src/app/membership/reducer.js